import React from 'react';
import { useParams } from 'react-router-dom';
import Header from '../components/Header';
import MarkDown from '../components/MarkDown';
import Footer from '../components/Footer';
import MANGA_LIST from '../data/mangaList';
import SienBanner from '../components/SienBanner';
import '../blog.css';

function Manga() {
  const { id } = useParams();
  const currentId = Number(id);
  const maxId = MANGA_LIST.reduce((max, item) => Math.max(max, item.id), 0);
  const hasPrev = Number.isInteger(currentId) && currentId > 1;
  const hasNext = Number.isInteger(currentId) && currentId < maxId;

  return (
    <div className="manga-page manga-frame">
      <Header />
      <div className="left-area">
        <SienBanner className="manga-sien-side" />
      </div>
      <div className="cont2">
      <MarkDown path={`/manga/${id}`} type="manga" />
      <div className="manga-nav">
        {hasPrev ? (
          <a href={`/manga/${currentId - 1}`}>← 前へ</a>
        ) : (
          <span />
        )}
        <a href="/manga">漫画一覧</a>
        {hasNext ? (
          <a href={`/manga/${currentId + 1}`}>次へ →</a>
        ) : (
          <span />
        )}
      </div>
      <SienBanner className="manga-sien-bottom" />
      </div>
      <Footer />
    </div>
  );
}

export default Manga;
